import React from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { Box, Typography, Link } from "@bca/ui-library";

import StarRating from "./StarRating";
import { formatMoney } from "../utils/formatMoney";
import { IProductPushable } from "../common/analytics/analytics.types";
import analytics from "../common/analytics/analytics";
import VehicleDetailsAnalytics from "../analytics/VehicleDetailsAnalytics.type";

const StyledLink = styled(Link)`
  ${css({
    fontSize: "body-small",
    fontWeight: "medium",
    width: "78px",
    zIndex: "1",
  })}
`;

const pushHPIAnalytics = (vehicleAnalytics: VehicleDetailsAnalytics) => {
  analytics.push<IProductPushable>({
    event: {
      name: "click",
      category: "link",
      label: "hpi-check",
      action: "navigate",
      section: "card",
    },
    product: {
      vehicle: [vehicleAnalytics],
    },
  });
};

const HPISpecCheck: React.FunctionComponent<{
  starRating?: number | null;
  price: number | null;
  anchorLink?: string;
  vehicleAnalytics: VehicleDetailsAnalytics;
}> = ({ starRating, price, anchorLink, vehicleAnalytics }) => {
  if (price === null || price === undefined || !Boolean(starRating)) {
    return null;
  }

  return (
    <>
      {anchorLink && (
        <StyledLink
          href={anchorLink}
          color="primary-light-blue"
          underline="always"
          id="#hpi-spec-check-table"
          target="_blank"
          onClick={() => pushHPIAnalytics(vehicleAnalytics)}
        >
          HPI Spec Check
        </StyledLink>
      )}
      <Box display="flex" flexDirection="column" alignItems="flex-end">
        <Typography
          variant="body-small"
          color="primary-navy-blue"
          my="0px"
          mb="4px"
        >
          {`+ ${formatMoney(price)}`}
        </Typography>
        <StarRating rating={starRating.toFixed(1)} />
      </Box>
    </>
  );
};

export default HPISpecCheck;
